<template>
  <b-form-group
    label="Gelir Tanımı"
    label-for="title"
  >
    <v-select
      v-model="dataItem.id_donation_groups"
      :options="donationGroups"
      label="title"
      :reduce="item => item.id"
      placeholder="Seçiniz"
      disabled
    >
      <template v-slot:option="option">
        <div class="font-weight-bold">
          {{ option.title }}
        </div>
        <div class="font-small-2 text-muted">
          {{ option.main_group }}
        </div>
      </template>
    </v-select>
  </b-form-group>
</template>

<script>
import {
  BFormGroup,
} from 'bootstrap-vue'
import vSelect from 'vue-select'

export default {
  name: 'DonationGroups',
  components: {
    BFormGroup,
    vSelect,
  },
  computed: {
    dataItem() {
      return this.$store.getters['accountActivities/transferDataItem']
    },
    donationGroups() {
      return this.$store.getters['donationGroups/dataList']
    },
  },
  created() {
    this.getDonationGroups()
  },
  methods: {
    getDonationGroups() {
      this.$store.dispatch('donationGroups/getDataList', {
        select: [
          'donation_groups.id AS id',
          'donation_groups.title AS title',
          'main_group.title AS main_group',
          'donation_groups.id_donation_types AS id_donation_types',
        ],
        where: {
          'donation_groups.id_donation_groups !=': null,
          'donation_groups.is_income': 1,
        },
      })
    },
  },
}
</script>
